import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, AlertTriangle, ArrowRight } from "lucide-react";

export default function ConnectReturn() {
  const navigate = useNavigate();
  const location = useLocation();
  const isRefresh = location.pathname.includes("refresh");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/connect/status").then(({ data }) => setStatus(data)).finally(() => setLoading(false));
  }, []);

  const ready = status?.has_account && status?.payouts_enabled && status?.details_submitted;

  return (
    <div className="max-w-md mx-auto" data-testid="connect-return-page">
      <div className="brut-card p-8 text-center pop-in">
        {loading && (
          <>
            <Loader2 className="mx-auto animate-spin text-[var(--cs-money-2)]" size={42} />
            <h1 className="font-display text-3xl font-black mt-4">Checking your setup…</h1>
          </>
        )}
        {!loading && ready && (
          <>
            <CheckCircle2 className="mx-auto text-[var(--cs-money-2)]" size={48} />
            <h1 className="font-display text-3xl font-black mt-4">You're set up for payouts!</h1>
            <p className="text-[var(--cs-ink-2)] mt-2">Future earnings can be cashed out straight to your bank.</p>
            <Link to="/wallet" className="brut-btn brut-btn-money mt-5 inline-flex" data-testid="go-wallet">
              Go to wallet <ArrowRight size={16} />
            </Link>
          </>
        )}
        {!loading && !ready && (
          <>
            <AlertTriangle className="mx-auto text-[var(--cs-flame)]" size={42} />
            <h1 className="font-display text-3xl font-black mt-4">
              {isRefresh ? "Let's try that again" : "A few more steps"}
            </h1>
            <p className="text-[var(--cs-ink-2)] mt-2">
              {status?.has_account
                ? "Stripe still needs more info before you can receive payouts."
                : "We couldn't find your Stripe Connect account. Please retry."}
            </p>
            <Link to="/wallet" className="brut-btn mt-5 inline-flex" data-testid="back-wallet">
              Back to wallet
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
